import {TouchSpin} from "../Functions/TouchSpin";
import {Popover} from "bootstrap";
import {initUserListSelect} from "./UserListSelect";
import DropdownHelper from "../Modules/Dropdown";

// this variable is set globally with a script-tag
declare var productListLoadingLabel: string;

let loadingOffset = 400;
let loadNextProductsEnabled = true;

/**
 * Load next Products in listview
 *
 * @param button
 * @return void
 */
const loadNextProducts = (button: HTMLElement) => {
    let nextPage = parseInt(button.dataset.currentpage ?? '1') + 1;
    let link = button.dataset.link;
    link = link.replace(new RegExp('~p[0-9]{0,10}\.html'), '~p' + nextPage + '.ajax');

    button.dataset.currentpage = nextPage.toString();

    const limitSelect = document.querySelector('select.limit-select') as HTMLSelectElement;
    if (limitSelect && limitSelect.value !== 'all') {
        loadNextProductsEnabled = false;
        return;
    }

    if (nextPage >= parseInt(button.dataset.maxpage)) {
        button.remove();
    } else {
        var originalText = button.textContent;
        button.setAttribute('disabled', 'disabled');
        button.textContent = productListLoadingLabel;
    }

    if (nextPage <= parseInt(button.dataset.maxpage)) {
        const loadingSpinner = button.closest('.further-products-loading').querySelector('.product-list-loading-spinner');

        const request = async () => {
            fetch(link)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                const productList = document.querySelector('.productlist');

                const lastRow = productList.querySelector('.last-row');
                if (lastRow) {
                    lastRow.classList.remove('last-row');
                }

                const temp = document.createElement('div');
                temp.innerHTML = data;
                const newProducts = temp.querySelector('.productlist').innerHTML;
                productList.insertAdjacentHTML('beforeend', newProducts);

                loadingSpinner?.classList.add('d-none');

                TouchSpin.init(productList.querySelectorAll('.productlist input[type="number"]'));


                const quantityInputNextProducts = document.querySelector('.productlist input.quantity-input');
                if (quantityInputNextProducts?.getAttribute('type') === 'text') {
                    TouchSpin.init('input.quantity-input');
                }

                // @ts-ignore
                $(productList).find('*[data-annotations]').annotations();
                // @ts-ignore
                $(productList).find('.price-async').prices();
                // @ts-ignore
                $(productList).find('.shopping-button-async').shoppingButton();
                // @ts-ignore
                $(productList).find('*[data-fetch-article-buy]').articleBuy();

                // @ts-ignore
                $('body').markSearchWord();

                const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
                if (popovers.length) {
                    Array.from(popovers).forEach((popoverEl) => {
                        const popover = Popover.getOrCreateInstance(popoverEl, {
                            container: 'body'
                        });
                    });
                }

                DropdownHelper.defaultInit();

                // @ts-ignore
                window.updateAnnotations();
                // @ts-ignore
                window.updateItemStatistics();

                initUserListSelect();

                if (nextPage < parseInt(button.dataset.maxpage)) {
                    button.textContent = originalText;
                    button.removeAttribute('disabled');
                    loadNextProductsEnabled = true;
                }
            })
            .catch(error => {
                console.error('Could not fetch product list:', error);

                loadingSpinner?.classList.add('d-none');
            });
        }

        loadingSpinner?.classList.remove('d-none');
        request();
    }
}

/**
 * Check if the next products should be loaded
 */
const isLoadNextProductsEnabled = () => {
    return loadNextProductsEnabled;
}

/**
 * Set if the next products should be loaded
 *
 * @param enabled
 */
const setLoadNextProductsEnabled = (enabled: boolean) => {
    loadNextProductsEnabled = enabled;
}

/**
 * Get the loading offset
 */
const getLoadNextProductsLoadingOffset = () => {
    return loadingOffset;
}

export function initLoadNextProducts () {

    let latestScrollY = window.scrollY;

    /**
     * Load next products on button click
     */
    document.body.addEventListener('click touchend', function (e) {
        const target = e.target as HTMLElement;

        if (!target.closest('[data-type="further-products"]')) {
            return;
        }

        setLoadNextProductsEnabled(false);
        loadNextProducts(target.closest('[data-type="further-products"]'));
    }, {passive: true});

    /**
     * Load next products on scroll
     */
    window.addEventListener('scroll', () => {
        const loadFurtherProducts = document.querySelector('[data-type="further-products"]') as HTMLElement;
        const loadingIndicatorElement: HTMLElement = loadFurtherProducts?.closest('.further-products-loading') ?? loadFurtherProducts;

        if (!loadingIndicatorElement) {
            return;
        }

        if (
            isLoadNextProductsEnabled()
            && loadingIndicatorElement
            && getBottom(loadingIndicatorElement) <= window.innerHeight && getBottom(loadingIndicatorElement) > 0 && window.scrollY > latestScrollY
        ) {
            setLoadNextProductsEnabled(false);
            loadNextProducts(loadFurtherProducts);
        }

        latestScrollY = window.scrollY;
    }, {passive: true});

    /**
     * Get bottom position of the element
     */
    const getBottom = (element: Element) => {
        return element.getBoundingClientRect().top + element.clientHeight;
    }
}
